import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { SpecificRent as SpecificDestinationModel } from 'models/specificRent';
import { getFormattedPrice } from 'utils/currency';

import { PreviewContainer, Item, ValuesContainer, Point } from '../styles';

interface Props {
  values: SpecificDestinationModel[];
  countryCurrency: string;
}

const PreviewItemsVehicle = ({ values, countryCurrency }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: countryCurrency, t });
    return formatted;
  };

  return (
    <PreviewContainer>
      {values.slice(0, 3).map((value) => (
        <Item key={`${value.pickup?.code}-${value.dropoff?.code}`}>
          <Item.Title>{value.pickup?.name}</Item.Title>
          <Item.Title>{value.dropoff?.name}</Item.Title>
          <ValuesContainer>
            <Item.Value>
              {value.dateVehicle && value.dateVehicle > 0
                ? `${value.dateVehicle}
                  ${t('rule.restriction.anticipationSuffix')}`
                : t('rule.restriction.withoutRestriction')}
            </Item.Value>
            <Point> • </Point>
            <Item.Value>
              {value.maxPrice ? formattedPrice(value.maxPrice) : t('rule.restriction.withoutRestriction')}
            </Item.Value>
          </ValuesContainer>
        </Item>
      ))}
    </PreviewContainer>
  );
};

export default PreviewItemsVehicle;
